import { motion } from "framer-motion";
import { JSX } from "react";

interface Props {
    logoSrc: string;
}

export const AppLoader = (props: Props): JSX.Element => {
    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "white",
                zIndex: 50,
            }}
        >
            <motion.img
                src={props.logoSrc}
                alt="Loading"
                animate={{
                    scale: [1, 1.1, 1],
                    opacity: [1, 0.7, 1],
                }}
                transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                style={{
                    width: "16rem",
                    height: "16rem",
                    objectFit: "contain",
                }}
            />
        </div>
    );
};

export default AppLoader;
